import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ProjectFormLayout from "layouts/ProjectFormLayout";
import themeProps from "theme/themes";
import calendar from "assets/icons/calendar.svg";
import { getCurrentDate, getNextMonthsDate } from "utils/time";
import { ProjectDto } from "common/dtos/ProjectDto";

interface ProjectTimePeriodProps {
  projectData: ProjectDto;
  setProjectData: any;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-items: space-between;
  padding: 10px 12px 10px 8px;
  border-radius: 12px;
  border: 1px solid ${(state: themeProps) => state.theme.border.highlighted};
`;

const Input = styled.input`
  border-radius: 12px;
  padding: 0 5px;
  width: 100px;
  border: none;
  outline: none;
`;

const Icon = styled.img`
  width: 100%;
`;

const Seperator = styled.p`
  font-size: 1.2rem;
  margin: 0 20px;
  font-weight: 500;
`;

const ProjectTimePeriod = ({
  projectData,
  setProjectData,
}: ProjectTimePeriodProps) => {
  const { t } = useTranslation("project");

  return (
    <ProjectFormLayout title={t("addTimePeriod")}>
      <Wrapper>
        <InputWrapper>
          <Input
            autoFocus
            placeholder={getCurrentDate()}
            value={projectData.startDate}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                startDate: e.target.value,
              })
            }
            maxLength={10}
          />
          <Icon src={calendar} />
        </InputWrapper>
        <Seperator>{t("common:until")}</Seperator>
        <InputWrapper>
          <Input
            placeholder={getNextMonthsDate()}
            value={projectData.dueDate}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                dueDate: e.target.value,
              })
            }
            maxLength={10}
          />
          <Icon src={calendar} />
        </InputWrapper>
      </Wrapper>
    </ProjectFormLayout>
  );
};

export default ProjectTimePeriod;
